import { dateRangePayload } from '../utils/datePresets';
import { chartTypeToQuery, getChartConfig } from '../utils/chartTypeMapping';
import { normalizeFiltersForQuery } from '../utils/reportFilters';
import { stripInvalidFilters } from '../utils/interveneFilters';

/**
 * Map builder UI state → backend QuerySpec JSON.
 */
export function buildQuerySpec(state) {
  const {
    dataset,
    accountId,
    campaignIds = [],
    leadsFormIds = [],
    chartType,
    questionType: legacyQuestionType,
    metric,
    dimension,
    aggregation = 'count',
    measureField,
    dateRange = {},
    filters = [],
    includedValues = [],
    tableColumns = [],
    scopeFormIds = [],
    templateId = '',
    botNumber = '',
    visualizationMode: legacyVizMode = 'auto',
    detailLevel = '',
    includeSessions,
  } = state || {};

  const mapped = chartType ? chartTypeToQuery(chartType) : null;
  const chartConfig = getChartConfig(chartType);
  const questionType = mapped?.questionType || legacyQuestionType;
  const visualizationMode = mapped?.visualizationMode || legacyVizMode;

  const selectedColumns = chartType === 'table'
    ? (tableColumns.length ? tableColumns : (dimension ? [dimension] : []))
    : [];

  const requestedForms = leadsFormIds.filter(Boolean).map(String);
  const scopedForms = (scopeFormIds || []).map(String).filter(Boolean);
  const leadsFormIdsForQuery = scopedForms.length
    ? requestedForms.filter((id) => scopedForms.includes(id)).length
      ? requestedForms.filter((id) => scopedForms.includes(id))
      : scopedForms
    : requestedForms;

  const isInterveneBenchmark = dataset === 'intervene' && metric === 'agent_response_time';
  const effectiveMetric = isInterveneBenchmark ? 'avg_agent_response' : metric;
  const effectiveDimension = isInterveneBenchmark
    ? (selectedColumns[0] || dimension || 'response_agent_username')
    : (chartConfig.showGroupBy && (selectedColumns[0] || dimension)
      ? (selectedColumns[0] || dimension)
      : undefined);

  const detailSettings = {};
  if (detailLevel) {
    detailSettings.detail_level = detailLevel;
  }
  if (typeof includeSessions === 'boolean') {
    detailSettings.include_sessions = includeSessions;
  }

  return {
    dataset,
    account_id: accountId,
    campaign_ids: campaignIds.filter(Boolean),
    leads_form_ids: leadsFormIdsForQuery,
    question_type: questionType,
    metric: effectiveMetric,
    metric_aggregation: aggregation || 'count',
    metric_field: aggregation !== 'count' && measureField ? measureField : undefined,
    dimension: effectiveDimension,
    columns: selectedColumns.length ? selectedColumns : undefined,
    date_range: dateRangePayload(dateRange),
    filters: normalizeFiltersForQuery([
      ...(chartConfig.showGroupBy && (effectiveDimension || dimension) && includedValues.length
        ? [{ field: effectiveDimension || dimension, operator: 'in', value: includedValues }]
        : []),
      ...stripInvalidFilters(filters),
    ]),
    template_id: dataset === 'whatsapp_templates' && templateId ? templateId : undefined,
    bot_number: dataset === 'whatsapp_templates' && botNumber ? botNumber : undefined,
    ...detailSettings,
    visualization: { mode: visualizationMode },
  };
}

export default buildQuerySpec;
